export {
  LegacyParityDealsLoader,
  useActiveParityOffer,
  useParityOffer,
} from './ParityOfferContext';
